module.exports = __webpack_public_path__ + "img/22251.42827d3a.png";